import { render, staticRenderFns } from "./BrandSection.vue?vue&type=template&id=ff01b06c&scoped=true"
import script from "./BrandSection.vue?vue&type=script&lang=js"
export * from "./BrandSection.vue?vue&type=script&lang=js"
import style0 from "./BrandSection.vue?vue&type=style&index=0&id=ff01b06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff01b06c",
  null
  
)

export default component.exports